function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Select, Button, Form, Input, Upload, InputNumber, Switch, Space, DatePicker, Alert, notification } from 'antd';
import ImgCrop from 'antd-img-crop';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';
import { PlusCircleFill } from "react-bootstrap-icons";
import Common from "../../includes/Common";
import dayjs from "dayjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var EditEvent = function EditEvent(_ref) {
  var handler = _ref.handler,
    event = _ref.event;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(event.free),
    _useState6 = _slicedToArray(_useState5, 2),
    free = _useState6[0],
    setFree = _useState6[1];
  var _useState7 = useState(event.attender_out),
    _useState8 = _slicedToArray(_useState7, 2),
    attenderOut = _useState8[0],
    setAttenderOut = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    cover = _useState10[0],
    setCover = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    longitude = _useState12[0],
    setLongitude = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    latitude = _useState14[0],
    setLatitude = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    catList = _useState16[0],
    setCatList = _useState16[1];
  var props = {
    listType: "picture-card",
    onPreview: function onPreview(file) {
      return false;
    },
    onRemove: function onRemove(file) {
      setCover(null);
    },
    beforeUpload: function beforeUpload(file) {
      setCover(file);
      return false;
    },
    accept: ".png,.jpg,.jpeg",
    maxCount: 1
  };
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setErrorMessage('');
    var formData = new FormData();
    formData.append("id", event.id);
    formData.append('label', values.label);
    formData.append('event_category_id', values.event_category_id);
    formData.append('contact', values.contact);
    formData.append('place', values.place);
    formData.append('description', values.description);
    formData.append('starts_at', values.starts_at);
    formData.append('ends_at', values.ends_at);
    formData.append('teaser_link', values.teaser_link);
    formData.append('place', values.place);
    formData.append('longitude', longitude);
    formData.append('latitude', latitude);
    formData.append('organization_id', organization.id);
    formData.append('attender_out', attenderOut);
    formData.append('free', free);
    formData.append('image_file', cover);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'editevent', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200) {
        handler();
      } else {
        window.scrollTo(0, 0);
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      window.scrollTo(0, 0);
      setIsFormLoading(false);
      setErrorMessage('Une erreur s\'est produite, ' + error.message);
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      label: event.label,
      email: event.email,
      address: event.address,
      event_category_id: event.event_category_id,
      contact: event.contact,
      description: event.description,
      place: event.place,
      starts_at: dayjs(event.starts_at),
      ends_at: dayjs(event.ends_at),
      teaser_link: event.teaser_link
    });
    axios.get("".concat(Common.baseApiUrl, "geteventcategories")).then(function (response) {
      if (response.data.status == 200) {
        setCatList([]);
        response.data.categories.forEach(function (c) {
          setCatList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
      } else {
        notification.error({
          message: "Erreur",
          description: "Une erreur est survenue pendant le chargement des données"
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue"
      });
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 5,
          md: 6,
          sm: 10,
          children: [/*#__PURE__*/_jsx("h5", {
            style: {
              color: '#645D5D'
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "MODIFIER CET EVENEMENT"
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
            layout: "vertical",
            size: "middle",
            form: form,
            onFinish: onFinish,
            autoComplete: "off",
            children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Alert, {
                banner: true,
                closable: true,
                style: {
                  marging: '5px 0px',
                  fontSize: '14px'
                },
                message: errorMessage,
                type: "error",
                showIcon: true
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "label",
              label: "Nom de l'\xE9v\xE8nement",
              rules: [{
                required: true,
                message: "Veuillez entrer le nom de l'évènement"
              }],
              children: /*#__PURE__*/_jsx(Input, {
                placeholder: "Saisir un nom"
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              label: "Choisir une image de couverture",
              children: /*#__PURE__*/_jsx(ImgCrop, {
                aspect: 16 / 9,
                rotationSlider: true,
                children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
                  children: /*#__PURE__*/_jsx("div", {
                    style: {
                      padding: "40px 120px"
                    },
                    children: /*#__PURE__*/_jsx(PlusCircleFill, {
                      size: 18
                    })
                  })
                }))
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              label: "Cat\xE9gorie",
              name: "event_category_id",
              rules: [{
                required: true,
                message: "Ce champ est obligatoire"
              }],
              children: /*#__PURE__*/_jsx(Select, {
                options: catList,
                placeholder: "Choisir une cat\xE9gorie"
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              label: "Description",
              name: "description",
              children: /*#__PURE__*/_jsx(TextArea, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "place",
              label: "lieu",
              children: /*#__PURE__*/_jsx(Input, {
                placeholder: "Entrez le lieu"
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "contact",
              label: "Infos contact",
              children: /*#__PURE__*/_jsx(Input, {
                placeholder: "Entrez un num\xE9ro pour infos"
              })
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "starts_at",
                  label: "Date debut",
                  children: /*#__PURE__*/_jsx(DatePicker, {
                    showTime: true
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "ends_at",
                  label: "Date de fin",
                  children: /*#__PURE__*/_jsx(DatePicker, {
                    showTime: true
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  label: "Autoriser-vous les sorties ?",
                  children: /*#__PURE__*/_jsx(Switch, {
                    defaultChecked: attenderOut == 1,
                    checkedChildren: "Oui",
                    unCheckedChildren: "Non",
                    onChange: function onChange(checked) {
                      setAttenderOut(checked == true ? 1 : 0);
                    }
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  label: "Entr\xE9e gratuite ?",
                  children: /*#__PURE__*/_jsx(Switch, {
                    defaultChecked: free == 1,
                    checkedChildren: "Oui",
                    unCheckedChildren: "Non",
                    onChange: function onChange(checked) {
                      setFree(checked == true ? 1 : 0);
                    }
                  })
                })
              })]
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "teaser_link",
              label: "Lien teaser Youtube",
              children: /*#__PURE__*/_jsx(Input, {
                placeholder: "Saisir un lien"
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                disabled: catList.length == 0,
                loading: isFormLoading,
                type: "primary",
                size: "large",
                htmlType: "submit",
                children: /*#__PURE__*/_jsx("b", {
                  children: "TERMINER"
                })
              })
            })]
          })]
        })
      })
    })
  });
};
export default EditEvent;